import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, breakpoints, borderRadius } = useTheme();
  return {
    searchAgeFilter: css`
      width: 100%;
    `,
    inputField: hasError => css`
      font-size: 1rem;
      font-family: 'FS Dillon';
      height: 3rem;
      padding: 0.75rem 1rem;
      display: block;
      width: 100%;
      border-radius: ${hasError
        ? `${borderRadius.m} ${borderRadius.m} 0 0`
        : `${borderRadius.m}`};
      border: 2px solid ${hasError ? '#dd221a' : colors.border_blue};
      background: #fff;
      text-align: center;
      ::placeholder {
        text-align: center;
      }
      ${hasError &&
      css`
        border-color: #dd221a;
        background-color: #fbe1df;
      `}

      &:hover,
      &:focus {
        outline: none;
        border-color: ${hasError ? '#dd221a' : colors.navy};
        background-color: ${colors.pale_blue};
      }
      /* Strict Keyboard Only State */
      &.keyboard-focus:focus {
        outline: 2px solid ${colors.skip_yellow};
        border: 2px solid ${hasError ? '#dd221a' : colors.border_black};
        background-color: ${hasError ? '#fbe1df' : colors.pale_blue};

        ${hasError &&
        css`
          border-color: #dd221a !important;
          background-color: #fbe1df;
        `}
      }

      ${breakpoints.s} {
        &.keyboard-focus:focus {
          outline: 2px solid ${colors.skip_yellow};
          border: 2px solid ${hasError ? '#dd221a' : colors.border_black};
          background-color: ${hasError ? '#fbe1df' : colors.pale_blue};
        }
      }
    `,
    errorMessage: css`
      display: flex;
      padding: 0.25rem 0.5rem;
      gap: 0.625rem;
      border-radius: 0 0 4px 4px;
      background: #dd221a;
      color: #fff;
      line-height: 1.25rem;
      letter-spacing: 0.015rem;
      align-items: center;
    `,
    listWrapper: css`
      width: 100%;
    `,
    chooseFilter: isSelected => css`
      position: relative;
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      align-items: center;
      padding: 8px 8px 8px 12px;
      border-radius: 80px;
      margin-bottom: 0.25rem;
      cursor: pointer;

      span {
        color: #5b6885;
        letter-spacing: 0.32px;
      }
      &:hover {
        outline: none;
        background-color: #eceef3;
      }
      ${breakpoints.s} {
        &:has(input:focus-visible) {
          border: 2px solid ${colors.border_black};
          outline: 2px solid ${colors.skip_yellow};
        }
      }

      ${isSelected &&
      css`
        background-color: #eceef3;
      `}
    `,
    optionCheckbox: css`
      position: absolute;
      opacity: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border-width: 0;

      & + span {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        color: #5b6885;
        border: 2px solid currentColor;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &:checked + span {
        color: #00539f;
        background-color: #fff;
      }

      &:checked + span::after {
        content: '';
        width: 0.25rem;
        height: 0.625rem;
        border: solid currentColor;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        display: block;
        margin-top: -3px;
      }
    `,
  };
};
